import { useMemo } from "react";
import { useJointBillServicePeriodListQuery } from "@services/jointBillServices/queries";
import { type IPeriod } from "@services/jointBillServices/types";
import { type IOverviewJointBillService } from "@services/overview/types";
import { capitalizeFirstLetter, convertYearMonthToDate } from "@utils/common";
import { formatDate } from "@utils/units";

interface IPeriodFilter extends IPeriod {
  label: string;
}

export const useJointBillServicePeriodFilters = (
  jointBillServiceIds: IOverviewJointBillService["jointBillServiceId"][],
): IPeriodFilter[] => {
  const { data: periods } = useJointBillServicePeriodListQuery();

  return useMemo(
    () =>
      jointBillServiceIds
        .reduce<IPeriod[]>((acc, jbsId) => {
          const jbsPeriods = periods?.find(
            (p) => p.jointBillServiceId === jbsId,
          )?.periods;
          jbsPeriods?.forEach((jbsPeriod) => {
            if (!acc.find((p) => p.periodId === jbsPeriod.periodId)) {
              acc.push(jbsPeriod);
            }
          });

          return acc;
        }, [])
        .sort((a, b) => b.periodId - a.periodId)
        .map((p) => {
          const date = convertYearMonthToDate(p);
          const label = `${formatDate(date, "yyyy")} m. ${capitalizeFirstLetter(
            formatDate(date, "LLLL"),
          )}`;
          return {
            ...p,
            label,
          };
        }),
    [jointBillServiceIds, periods],
  );
};
